export const COUNTERS_TYPES = {
    value: 'value',
    error: 'error',
    success: 'success',
}